import PropTypes from 'prop-types';
import { Input } from 'antd';
import { forwardRef, useEffect, useState } from 'react';
import { composeEvent } from '@icp/utils';

const NoI18nTextarea = forwardRef(function NoI18nTextarea(props, ref) {
  const { value: valueProp, onChange, onBlur, changeDelayToBlur, ...other } = props;

  const [value, setValue] = useState(valueProp);

  useEffect(() => {
    setValue(valueProp);
  }, [valueProp]);

  const handleChange = (event) => {
    // 输入中文时，拼音没有打完就触发 onChange，由于有useEffect导致textArea值不对带上了拼音，这里任何时候都去setValue
    setValue(event.target.value);
    if (!changeDelayToBlur) {
      onChange(event.target.value);
    }
  };

  const handleBlur = (event) => {
    if (changeDelayToBlur) {
      onChange(event.target.value);
    }
  };

  return (
    <Input.TextArea
      {...other}
      value={value ?? ''}
      onChange={handleChange}
      onBlur={composeEvent(handleBlur, onBlur)}
      ref={ref}
    />
  );
});

NoI18nTextarea.propTypes = {
  changeDelayToBlur: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default NoI18nTextarea;
